import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from './assets/Logo.png';
import "./AddCar.css";

function AddCar() {
  const [user, setUser] = useState(null);
  const [cars, setCars] = useState([]);
  const [carBrands, setCarBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [carModels, setCarModels] = useState([]);
  const [selectedModel, setSelectedModel] = useState("");
  const [trims, setTrims] = useState([]);
  const [selectedTrim, setSelectedTrim] = useState("");
  const navigate = useNavigate();


  // آرایه سال‌ها
  const years = Array.from({ length: 2025 - 2005 + 1 }, (_, i) => 2005 + i);

  useEffect(() => {
    // دریافت اطلاعات کاربر از localStorage
    const storedUser = localStorage.getItem("userData");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      const normalizedUser = {
        name: parsedUser.Name,
        phone: parsedUser.Phone,
        email: parsedUser.Email,
        address: parsedUser.Address,
        postalCode: parsedUser["Postal Code"]
      };
      setUser(normalizedUser);
    }
    // دریافت برندهای خودرو از سرور
    fetch("https://carcure.ca/backend/car-brands")
      .then(res => res.json())
      .then(data => setCarBrands(data))
      .catch(err => console.error("Error fetching car brands:", err));
  }, []);

// دریافت مدل‌های خودرو از سرور
const fetchCarModels = async (brand, year) => {
  try {
    const response = await fetch(`https://carcure.ca/backend/car-models/${brand}/${year}`);
    if (!response.ok) {
      throw new Error(`Error fetching models: ${response.statusText}`);
    }
    const models = await response.json();
    console.log("Models received:", models);
    setCarModels(models.map(model => String(model)));
  } catch (error) {
    console.error("Error fetching car models:", error);
    setCarModels([]);
  }
};

// دریافت نوع تریم از سرور بر اساس برند، مدل و سال
const fetchTrims = async (brand, model, year) => {
  try {
    const url = `https://carcure.ca/backend/car-trims/${brand}/${model}/${year}`;
    console.log("📡 Fetching trims from:", url);

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`❌ Error fetching trim types: ${response.statusText}`);
    }

    const trims = await response.json();
    console.log("✅ Trims received:", trims);

    setTrims(trims.map(t => String(t))); // تبدیل به رشته برای اطمینان
  } catch (error) {
    console.error("❌ Error fetching trim types:", error);
    setTrims([]);
  }
};

  // Handler تغییر انتخاب برند
  const handleBrandChange = (e) => {
    const brand = e.target.value;
    setSelectedBrand(brand);
    // ریست کردن مراحل بعدی
    setSelectedYear("");
    setCarModels([]);
    setSelectedModel("");
    setTrims([]);
    setSelectedTrim("");
  };

  // Handler تغییر انتخاب سال
  const handleYearChange = (e) => {
    const year = e.target.value;
    setSelectedYear(year);
    if (selectedBrand && year) {
      fetchCarModels(selectedBrand, year);
    }
    // ریست مدل و موتور
    setSelectedModel("");
    setTrims([]);
    setSelectedTrim("");
  };

  // Handler تغییر انتخاب مدل
  const handleModelChange = (e) => {
    const model = e.target.value;
    setSelectedModel(model);
    if (selectedBrand && selectedYear && model) {
      fetchTrims(selectedBrand, model, selectedYear);
    }
    setSelectedTrim("");
  };

  // تابع برای دریافت مسیر لوگو
 const getLogoPath = (brand) => {
  return `${process.env.PUBLIC_URL}/assets/logos/${brand}.svg`;
};


  const handleSaveCar = async () => {
    if (!user?.email || !selectedBrand || !selectedYear || !selectedModel || !selectedTrim) {
      alert("Please complete all fields!");
      return;
    }
    const carData = {
      email: user.email,
      brand: selectedBrand,
      year: selectedYear,
      model: selectedModel,
      trim: selectedTrim
    };
    try {
      const response = await fetch("https://carcure.ca/backend/save-car", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(carData)
      });
      const data = await response.json();
      alert(data.message);
      if (data.message.includes("✅")) {
        navigate("/customer-dashboard");
      }
    } catch (error) {
      console.error("Error saving car:", error);
      alert("Error saving the vehicle. Please search again.");
    }
  };

  return (
    <>
      <header className="header-addcar">
        <img src={logo} alt="Logo" className="header-logo" />
      </header>
      <div className="main-container">
        <div className="CarSelection">
          <h1>🚗 Add a New Car</h1>
          <hr />
          {user ? <p>Welcome {user.name}, please add your car details.</p> : <p>Loading...</p>}
          <div className="button-container">
            <button
              className="confirm-button"
              onClick={() => navigate("/add-car-vin")}
            >
              🔍 Use VIN to Auto Fill
            </button>
          </div>
          
          <div className="form-container">

            {/* 1. انتخاب برند */}
            <div className="dropdown-container">
              <label>Select Car Brand:</label>
              <select onChange={handleBrandChange} value={selectedBrand}>
                <option value="">Choose Brand</option>
                {carBrands.map((brand, index) => (
                  <option key={index} value={brand}>
                    <img src={getLogoPath(brand)} alt={brand} style={{ width: 20, marginRight: 10 }} />
                    {brand}
                  </option>
                ))}
              </select>
            </div>

            {/* 2. انتخاب سال */}
            {selectedBrand && (
              <div className="dropdown-container">
                <label>Select Year:</label>
                <select onChange={handleYearChange} value={selectedYear}>
                  <option value="">Choose Year</option>
                  {years.map((year, index) => (
                    <option key={index} value={year}>{year}</option>
                  ))}
                </select>
              </div>
            )}

            {/* 3. انتخاب مدل خودرو */}
            {selectedYear && carModels.length > 0 && (
              <div className="dropdown-container">
                <label>Select Car Model:</label>
                <select onChange={handleModelChange} value={selectedModel}>
                  <option value="">Choose Model</option>
                  {carModels.map((model, index) => (
                    <option key={index} value={model}>{model}</option>
                  ))}
                </select>
              </div>
            )}
            
            {/* 4. انتخاب نوع موتور */}
            {selectedModel && trims.length > 0 && (
              <div className="dropdown-container">
                <label>Select Trim:</label>
                <select onChange={(e) => setSelectedTrim(e.target.value)} value={selectedTrim}>
                  <option value="">Choose Trim</option>
                  {trims.map((trim, index) => (
                    <option key={index} value={trim}>{trim}</option>
                  ))}
                </select>
              </div>
            )}
            <div className="button-container">
              <button className="confirm-button" onClick={handleSaveCar}>✅ Save Car</button>
              <button className="cancel-button" onClick={() => navigate("/customer-dashboard")}>⬅️ Back to Dashboard</button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default AddCar;
